import { render, staticRenderFns } from "./address-street-dadata.vue?vue&type=template&id=8317b414&scoped=true"
import script from "./address-street-dadata.vue?vue&type=script&lang=js"
export * from "./address-street-dadata.vue?vue&type=script&lang=js"
import style0 from "./address-street-dadata.vue?vue&type=style&index=0&id=8317b414&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8317b414",
  null
  
)

export default component.exports